import type { ConceptDef } from '../types';

export const receptiveFeatures: ConceptDef = {
  kind: 'tileMatch',
  id: 'receptive-features',
  label: 'Receptive Features',
  category: 'Receptive',
  description: 'Hear a feature and tap an item that has it.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'has a tail', answer: '🐶 dog' },
      { say: 'has wheels', answer: '🚗 car' },
      { say: 'has petals', answer: '🌹 rose' },
      { say: 'has wings', answer: '🐦 bird' },
      { say: 'has leaves', answer: '🌳 tree' },
      { say: 'has stripes', answer: '🦓 zebra' },
    ],
  },
};
